import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleMenuClick = (path) => {
        window.location.href = path;
        setMenuOpen(false); // Close the menu after redirecting
    };

    return (
        <>
            <header className="navbar">
                <div className="navbar-logo">
                    TureMedicine
                </div>
                <div className="navbar-buttons">
                    <button 
                        className="navbar-button patient-button" 
                        onClick={() => window.location.href = '/login?type=patient'}
                    >
                        patient
                    </button>
                    <button 
                        className="navbar-button doctor-button" 
                        onClick={() => window.location.href = '/doctor-login'}
                    >
                        Doctor
                    </button>
                </div>

                {/* Hamburger Menu Icon (only on mobile) */}
                <div className="hamburger-icon" onClick={toggleMenu}>
                    {menuOpen ? 'X' : '☰'} {/* Change icon based on menu state */}
                </div>
            </header>

            {/* App Menu */}
            {(menuOpen || window.innerWidth > 768) && (
                <div className="app-menu">
                    <div className="menu-nav-inner">
                        <ul className="menu-list">
                            <li className="menu-item" onClick={() => handleMenuClick('/')}>Home</li>
                            <li className="menu-item" onClick={() => handleMenuClick('/services')}>Our Services</li>
                            <li className="menu-item" onClick={() => handleMenuClick('/about')}>About Us</li>
                            <li className="menu-item" onClick={() => handleMenuClick('/contact')}>Contact Us</li>
                            <li className="menu-item" onClick={() => handleMenuClick('/faq')}>FAQs</li>
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};

export default Navbar;